import { render, staticRenderFns } from "./template-entity-import.vue?vue&type=template&id=afddf8de"
import script from "./template-entity-import.vue?vue&type=script&lang=js"
export * from "./template-entity-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports